const appearAnimationStore = new Map();

export { appearAnimationStore };
